import { IStrings } from 'localization/IStrings';
import { QuickFilter } from '../InventoryItemsList';

export const createQfRecord = (strings: IStrings): Record<QuickFilter, string> => {
	return {
		all: strings.all,
		hearingInstrument: strings.hearingAids,
	};
};
